import { render, staticRenderFns } from "./notes-view-section.html?vue&type=template&id=f6db7706&scoped=true&external"
import script from "./notes-view-section.js?vue&type=script&lang=js&external"
export * from "./notes-view-section.js?vue&type=script&lang=js&external"
import style0 from "./notes-view-section.scss?vue&type=style&index=0&id=f6db7706&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6db7706",
  null
  
)

export default component.exports